@use "../../sass/variables/animation";
@use "../../sass/variables/colors";
@use "../../sass/variables/dimensions";
@use "../../sass/variables/typography";
@use "../../sass/mixins/clearfix";
@use "../../sass/mixins/font-family";

.ux-collapsible {
  @include clearfix.clearfix();

  &-content {
    &__container {
      overflow: hidden;
      transition: height animation.$animationSpeed-fast ease;
    }

    &__inner {
      @include clearfix.clearfix();

      overflow: visible;
      transition: opacity animation.$animationSpeed-fast ease;
    }
  }

  &-button {
    @include font-family.font(light);

    align-items: center;
    appearance: none;
    background: transparent none;
    border: 0 none transparent;
    cursor: pointer;
    display: inline-flex;
    flex-flow: row nowrap;
    font-size: typography.$size-text-medium-plus;
    justify-content: center;
    margin: auto;
    outline: none;

    &__container {
      padding: dimensions.$dim-15 0;
    }

    &__spacer {
      flex: 0 0 dimensions.$dim-10;
    }

    &__label,
    &__icon {
      display: inline-block;
      white-space: nowrap;
    }
  }

  &-button__container--centered {
    text-align: center;
  }

  &-arrow {
    display: block;
    height: auto;
    transform: none;
    transition: transform animation.$animationSpeed-fast ease;
    transition-delay: animation.$animationSpeed-fast;
    width: 16px;
  }

  &--collapsed {
    .ux-collapsible-content__container {
      height: 0;
    }

    .ux-collapsible-content__inner {
      opacity: 0;
    }
  }

  &--expanded {
    .ux-collapsible-content__container {
      height: auto;
      overflow: visible;
    }

    .ux-collapsible-content__inner {
      opacity: 1;
      transition-duration: animation.$animationSpeed-normal;
    }

    .ux-collapsible-arrow {
      transform: rotate(180deg);
    }
  }

  &--direction-bottom {
    h2 {
      margin-top: 0;
    }
  }

  &--accordion {
    .ux-collapsible-button__container {
      align-items: flex-start;
      background-color: colors.$color-blue-6;
      border-bottom: 0;
      padding: 15px 30px;
    }

    .ux-collapsible-button {
      display: flex;
      justify-content: space-evenly;
      width: 100%;
    }

    .ux-collapsible-button__label {
      font-size: 13px;
      font-weight: 800;
    }
  }
}
